<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/06-JS-check-your-resume.svg"
                class="img-fluid"
                alt="Check your resume"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
            <!-- <img
                src="@/assets/img/_content/6.AdobeStock_322904605.png"
                class="img-fluid"
                alt="Check your resume"
                srcset=""
              > -->
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row py-2">
        <div class="col-md-5 bg-img bg-img--job-search-06">
          <!-- <img
            src="assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md px-4">
          <p>Before you send anyone your resume, make sure it includes…</p>
          <ul>
            <li>A header with your contact information</li>
            <li>A tagline or profile statement </li>
            <li>A summary of your qualifications</li>
            <li>Your education</li>
            <li>Your work experience</li>
          </ul>
          <div class="learn-more learn-more--green">
            <p><strong>Learn more</strong></p>
            <p>Use <a
                :href="`${publicPath}docs/Tip sheets and other materials/2- Resume Blank Template.docx`"
                target="_blank"
              >this template</a> to build your resume.</p>
          </div>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
